import { render, staticRenderFns } from "./OrganizationVehicles.vue?vue&type=template&id=0b210d57"
import script from "./OrganizationVehicles.vue?vue&type=script&lang=js"
export * from "./OrganizationVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports